import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
export class PasswordStrengthIndicator extends Component {
  static displayName = 'PasswordStrengthIndicator';

  static propTypes = {
    strength: PropTypes.oneOf(['weak', 'medium', 'strong'])
  };

  static defaultProps = {
    strength: undefined
  };

  render() {
    let { strength } = this.props;
    let component = null;
    if (strength) {
      component = (
        <div className={classnames('password-indicator', strength)}>
          <span className="label"> Strength: </span>
          <span className="indicator">{strength} </span>
        </div>
      );
    }

    return component;
  }
}
